
// // title amount categorgy date note created by 



import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Popup from "../../../base-components/Popup";
import CustomModal from "../../../base-components/CustomModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PhoneInput from "react-phone-input-2";
import {
  faCircleCheck,
  faEye,
  faPen,
  faTrash,
  faDownload,
  faWarning,
} from "@fortawesome/free-solid-svg-icons";
import TablePaginationActions from "../../../base-components/TablePaginationActions";
import { Box, Table, TableBody, CircularProgress, TableCell, TableFooter, TableHead, TablePagination, TableRow, IconButton, Menu, MenuItem } from "@mui/material";
import { useFormik } from "formik";
import Tooltip from "@mui/material/Tooltip";
import { ExpenseSchema } from "../../../schemas";
import { ExpenseReport } from "./ExpenseReport";
import dayjs from "dayjs";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { getSessionUser, hasPermission, isDynamicStaffRole } from "../../../utils/roleAccess";
import { PageHeader } from "../../../ui";

const BASE_URL = process.env.REACT_APP_BASE_URL;

function Expense() {
  const navigate = useNavigate();
  const [expenseToDelete, setexpenseToDelete] = useState("");
  const [expenseToUpdate, setExpenseToUpdate] = useState("");
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);

  const [isSuccessAlert, setIsSuccessAlert] = useState(false);
  const [isFaliureAlert, setIsFailureAlert] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failureMessage, setFailureMessage] = useState("");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [locations, setLocations] = useState([]);
  const [expense, setExpense] = useState([]);
  const [selectedExpense, setSelectedExpense] = useState(null);
  const [company_id, setCompanyID] = useState("");
  const [user_id, setUserId] = useState("");
  const [location_id, setLocationId] = useState("");
  const [role, setRole] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [filteredexpense, setFilteredExpense] = useState("");
  const [buttonLoading, setButtonLoading] = useState(false);

  // Anchor state for the actions menu
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedExpenseId, setSelectedExpenseId] = useState(null);
  const openAnchor = Boolean(anchorEl);
  const handleClickAnchor = (event, expenseId) => {
    setAnchorEl(event.currentTarget);
    setSelectedExpenseId(expenseId);
  };
  const handleCloseAnchor = () => {
    setAnchorEl(null);
    setSelectedExpenseId(null);
  };

  useEffect(() => {
    const sessionStr = sessionStorage.getItem("user-info");
    if (sessionStr) {
      const session = JSON.parse(sessionStr);
      setRole(session.user.role);
      setUserId(session.user._id);
      setCompanyID(session.user.company_id);
      setLocationId(session.user.location_id);
      console.log("ha bhai", session.user.company_id);
    } else {
      navigate("/login");
    }
  }, []);

  useEffect(() => {
    if (role) {
      setLoading(true);
      getAllExpenses();
      getLocation();
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  }, [role]);

  const getAllExpenses = () => {
    if (!role) return;

    let endpoint = "";
    console.log(role);
    if (role === "Admin") {
      endpoint = `expenses/getExpenseByCompanyID/${company_id}`;
    } else if (role === "ClubAdmin") {
      endpoint = `expenses/getExpenseByLocationID/${location_id}`;
    } else if (isDynamicStaffRole(role)) {
      endpoint = `expenses/getExpenseByLocationID/${location_id}`;
    }

    console.log("Role:", role);
    console.log("Company ID:", company_id);
    console.log("Endpoint:", endpoint);
    fetch(BASE_URL + endpoint)
      .then((response) => response.json())
      .then((data) => {
        setExpense(data.expenses); 
        setFilteredExpense(data.expenses);
        setLoading(false); 
      })
      .catch((error) => {
        console.error("Error fetching gym assets:", error); 
        setLoading(false); 
      });
  };

  const getExpenseById = (id) => {
    fetch(`${BASE_URL}expenses/getExpenseByID/${id}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.expense) {
          setSelectedExpense(data.expense);
          console.log("Updated selectedMember:", data.expense); 
          setValues({
            title: data.expense.title,
            company_id: data.expense.company_id,
            location_id: data.expense.location_id,
            amount: data.expense.amount,
            description: data.expense.description,
            category:data.expense.category,
          });
        } else {
          console.error("No Expense member found.");
          setIsFailureAlert(true);
          setFailureMessage("No Expense found for the provided ID.");
          setIsPopupOpen(true);
          setTimeout(() => {
            setIsPopupOpen(false);
          }, 5000);
        }
      })
      .catch((error) => {
        console.error("Error fetching expense by ID:", error);
        setIsFailureAlert(true);
        setFailureMessage("Failed to fetch expense information.");
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      });
  };
console.log(selectedExpense,"expense")
  async function getLocation() {
    if (!role) return;

    let endpoint = "";
    console.log(role);
    if (role === "SuperAdmin") {
      endpoint = "locations/getLocations";
    } else if (role === "Admin") {
      endpoint = `locations/getLocationsByCompanyID/${company_id}`;
    }

    await fetch(BASE_URL + endpoint)
      .then((response) => response.json())
      .then((data) => {
        setLocations(data.locations);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const handleAddExpense = async (values, actions) => {
    setButtonLoading(true);
    console.log("Values before save:", values);
    values.company_id = company_id;
    values.created_by = user_id;

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(values),
    };

    try {
      const response = await fetch(
        BASE_URL + `expenses/create-expense`,
        requestOptions
      );

      // Log the full response details
      console.log("Response status:", response.status);

      if (!response.ok) {
        const errorMessage = await response.text();
        console.error("Error message from server:", errorMessage);
        setIsFailureAlert(true);
        setFailureMessage(`Failed to add Expense: ${errorMessage}`);
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      } else {
        const responseData = await response.json();
        console.log("Response data:", responseData);

        // if (responseData && responseData.expenses) {
          setIsAddModalOpen(false);
          actions.resetForm();
          getAllExpenses();
          setIsSuccessAlert(true);
          setSuccessMessage(responseData.message);
          setIsPopupOpen(true);
          setTimeout(() => {
            setIsPopupOpen(false);
          }, 5000);
        // } else {
        //   console.error("Unexpected response data:", responseData);
        //   setIsFailureAlert(true);
        //   setFailureMessage(responseData.message);
        //   setIsPopupOpen(true);
        //   setTimeout(() => {
        //     setIsPopupOpen(false);
        //   }, 5000);
        // }
      }
    } catch (error) {
      console.error("Caught error:", error);
      setIsFailureAlert(true);
      setFailureMessage("Failed to add Expense");
      setIsPopupOpen(true);
      setTimeout(() => {
        setIsPopupOpen(false);
      }, 5000);
    } finally {
      setButtonLoading(false);
    }
  };
  console.log("ffc", company_id);
 

  const handleUpdateExpense = async (values, actions) => {
    setButtonLoading(true);
    values.company_id = company_id;
    values.created_by = user_id;

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(values),
    };

    try {
      const response = await fetch(
        `${BASE_URL}expenses/update-expense/${expenseToUpdate}`,
        requestOptions
      );

      if (!response.ok) {
        const responseData = await response.json();
        setIsFailureAlert(true);
        setFailureMessage(responseData.message);
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      } else {
        const responseData = await response.json();
        actions.resetForm();
        setIsUpdateModalOpen(false);

        getAllExpenses();
        setIsSuccessAlert(true);
        setSuccessMessage(responseData.message);
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      }
    } catch (error) {
      console.error("Caught error:", error);
      setIsFailureAlert(true);
      setFailureMessage("Failed to Update Staff");
      setIsPopupOpen(true);
      setTimeout(() => {
        setIsPopupOpen(false);
      }, 5000);
    }
    finally {
      setButtonLoading(false);
    }
  };
  console.log("update", company_id);

  function deleteExpense() {
    setButtonLoading(true);
    const requestOptions = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    };
    fetch(BASE_URL + `expenses/delete-expense/${expenseToDelete}`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        getAllExpenses();
        setIsDeleteModalOpen(false);
        setIsSuccessAlert(true);
        setSuccessMessage("Expense deleted Successfully");
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      })
      .catch((error) => {
        console.log(error);
        setIsFailureAlert(true);
        setFailureMessage("Failed to delete Staff");
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      }).finally(() => {
        setButtonLoading(false)
      });
  }
  

  function toggleAddModal() {
    setIsAddModalOpen(!isAddModalOpen);
    resetForm();
  }
  function toggleViewModal() {
    setIsViewModalOpen(!isViewModalOpen);
    resetForm();
  }

  function toggleUpdateModal() {
    setIsUpdateModalOpen(!isUpdateModalOpen);
    resetForm();
  }
  function toggleDeleteModal() {
    setIsDeleteModalOpen(!isDeleteModalOpen);
  }

  function showAddModal(id) {
    setIsAddModalOpen(true);
  }
  function showViewModal(id)
   {
    
    console.log("Expense ID:", id);
    getExpenseById(id);
    setIsViewModalOpen(true);
  }
  const showUpdateModal = (id) => {
    getExpenseById(id);
    setExpenseToUpdate(id);
    setIsUpdateModalOpen(true);
  };

  function showDeleteModal(id) {
    setexpenseToDelete(id);
    setIsDeleteModalOpen(true);
  }
   const handleDownload=()=>{
            ExpenseReport(filteredexpense)
        }

  const totalPages = Math.ceil((filteredexpense?.length || 0) / rowsPerPage);


  const indexOfLastRow = (page + 1) * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredexpense?.slice(indexOfFirstRow, indexOfLastRow);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleFilter = () => {
    setLoading(true);
    let filtered = expense; 
    console.log("All Transactions:", filtered);

    if (fromDate && toDate) {
        // Convert fromDate and toDate to Date objects and remove the time part
        const startFilterDate = new Date(fromDate);
        const endFilterDate = new Date(toDate);
        
        startFilterDate.setHours(0, 0, 0, 0); // Set time to start of the day
        endFilterDate.setHours(23, 59, 59, 999); // Set time to end of the day

        filtered = filtered.filter(expenses => {
            const creationDate = expenses?.created_at ? new Date(expenses.created_at) : null;
            if (!creationDate) return false;
            
            creationDate.setHours(0, 0, 0, 0); // Remove time from creation date

            return creationDate >= startFilterDate && creationDate <= endFilterDate;
        });
    }

    console.log("Filtered Transactions:", filtered);
    setFilteredExpense(filtered);

    setTimeout(() => {
        setLoading(false);
    }, 1000);
};


  const {
    values,
    touched,
    errors,
    handleBlur,
    handleChange,
    handleSubmit,
    setValues,
    resetForm,
    setFieldValue,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
    //   company_id:  " ",
      location_id: role === "ClubAdmin" ? location_id :'' ,
      title: "",
      description: "",
      amount: "",
      category: "",
      company_id: "",
      created_by: "user_id",
    },
    validationSchema: ExpenseSchema ,
    onSubmit: (values, actions) => {
      console.log("Form Submitted:", values);

      if (isAddModalOpen) {
        handleAddExpense(values, actions);
      } else if (isUpdateModalOpen) {
        // handleUpdateExpense(values, actions);
        console.log('Update Expense Disabled for now');
      } else {
        console.error("No valid action specified for submission.");
      }
    },
  });
  console.log(values,"values")

  return (
    <>

      <div className="m-5">
        <PageHeader
          title="Expenses"
          actions={
            <>
              {hasPermission(getSessionUser(), 'reporting:export') && (
              <div className="text-gx-navy hover:cursor-pointer hover:text-gx-teal">
                <Tooltip title="Download" arrow>
                  <FontAwesomeIcon icon={faDownload} fontSize="30px" onClick={handleDownload} />
                </Tooltip>
              </div>
              )}
              {hasPermission(getSessionUser(), 'expense:create') && (
              <button className="gx-cta" onClick={showAddModal}>
                Add Expense
              </button>
              )}
            </>
          }
        />
      </div>
      <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8 mx-5">
  {/* From Date Input */}
  <div className="flex items-center gap-2 w-full md:w-auto">
    <label className="text-gx-ink font-semibold whitespace-nowrap">From:</label>
    <input
      type="date"
      value={fromDate}
      onChange={(e) => setFromDate(e.target.value)}
      className="border border-gx-border rounded-md py-1 px-3 outline-0 text-gx-ink-soft w-full md:w-48"
    />
  </div>

  {/* To Date Input */}
  <div className="flex items-center gap-2 w-full md:w-auto">
    <label className="text-gx-ink font-semibold whitespace-nowrap">To:</label>
    <input
      type="date"
      value={toDate}
      onChange={(e) => setToDate(e.target.value)}
      disabled={!fromDate}
      min={fromDate}
      className="border border-gx-border rounded-md py-1 px-3 outline-0 w-full md:w-48"
    />
  </div>

  {/* Fetch Expenses Button */}
  <div className="w-full md:w-auto">
    <button
      onClick={handleFilter}
      className="bg-green-700 text-white hover:bg-green-800 py-1 px-2 rounded-md flex items-center justify-center gap-2 w-full md:w-auto"
    >
      Fetch Expenses
    </button>
  </div>
</div>

      { loading ? (
          
            <div className="flex justify-center items-center mt-20 relative">
              {/* SVG Gradient Definition */}
              <svg width="0" height="0">
                <defs>
                  <linearGradient id="gradientColors" x1="1" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#D71920" />
                    <stop offset="100%" stopColor="#F7931E" />
                  </linearGradient>
                </defs>
              </svg>
      
              {/* Circular Progress with Gradient Stroke */}
              <CircularProgress
                thickness={4}
                size={35}
                sx={{
                  'svg circle': {
                    stroke: 'url(#gradientColors)', // Apply gradient stroke
                  },
                }}
              />
            </div>
          
        ) :  filteredexpense && filteredexpense.length !== 0 ? (
        <Box className="bg-gx-surface rounded-gx border border-gx-border shadow-gx m-5 animate-fadeIn overflow-y-auto overflow-x-auto">
          <Table>
            <TableHead>
              <TableRow>
                {/* <TableCell>Location</TableCell> */}
                <TableCell>Title</TableCell>
                <TableCell>Amount </TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Category</TableCell>
                <TableCell>CreatedBy </TableCell>
                <TableCell>Date </TableCell>
                {/* <TableCell>Actions</TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {currentRows.map((expenses, index) => (
                <TableRow hover key={index}>
                  {/* <TableCell>{expenses.location_id}</TableCell> */}
                  <TableCell>{expenses.title}</TableCell>
                  <TableCell>{expenses.amount}</TableCell>
                  <TableCell>{expenses.description}</TableCell>
                  <TableCell>{expenses.category}</TableCell>
                  <TableCell>{expenses.created_by.name}</TableCell>
                  <TableCell>{dayjs(expenses.created_at).format("MMM DD, YYYY")}</TableCell>

                  <TableCell>
                  {/* {role !== "ClubAdmin" && ( */}
                    {/* <Tooltip title="Actions">
                      <IconButton onClick={(event) => handleClickAnchor(event, expenses._id)}>
                        <MoreVertIcon />
                      </IconButton>
                    </Tooltip>
                    <Menu anchorEl={anchorEl} open={openAnchor} onClose={handleCloseAnchor}>
                      <MenuItem
                        onClick={() => {
                          handleCloseAnchor();
                          showViewModal(selectedExpenseId);
                        }}
                      >
                        <FontAwesomeIcon icon={faEye} className='mr-2'/> View 
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          handleCloseAnchor();
                          showUpdateModal(selectedExpenseId);
                        }}
                      >
                        <FontAwesomeIcon icon={faPen} className='mr-2' /> Update
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          handleCloseAnchor();
                          showDeleteModal(selectedExpenseId);
                        }}
                      >
                        <FontAwesomeIcon icon={faTrash} className='mr-2'/> Delete
                      </MenuItem>
                    </Menu> */}
                  {/* )} */}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                  colSpan={12}
                  count={filteredexpense.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  slotProps={{
                    select: {
                      inputProps: {
                        "aria-label": "rows per page",
                      },
                      native: true,
                    },
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </Box>
      ) : (
        <div className="bg-gx-border w-ful p-3 mt-10 rounded-lg m-10">
          <h3 className="text-xl font-bold text-center text-gx-ink-soft">
            No Records Found
          </h3>
        </div>
      )}



<CustomModal
  isModal={isAddModalOpen || isUpdateModalOpen}
  handleModal={() => {
    if (isAddModalOpen) {
      toggleAddModal();
    } else if (isUpdateModalOpen) {
      toggleUpdateModal();
    }
  }}
  size="2xl"
>
  <h1 className="font-bold text-3xl text-gx-ink-soft p-5 border-b mx-2">
    {isAddModalOpen ? "Add Expense" : "Update Expense "}
  </h1>

  <form
    onSubmit={handleSubmit}
    className="text-gx-ink-soft m-5"
    autoComplete="off"
  >
    <div>
      <input type="hidden" name="company_id" value={values.company_id} />
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-4">
      <div className="w-full">
        <label>
          Title <span className="text-red-600">*</span>
        </label>
        <input
          type="text"
          name="title"
          placeholder="Enter title"
          value={values.title}
          className={`
            border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 
            ${errors.title && touched.title ? "border-red-600" : ""}
          `}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.title && errors.title ? (
          <p className="text-red-500 pl-2 italic">{errors.title}</p>
        ) : null}
      </div>
      <div className="w-full">
        <label>
          Amount <span className="text-red-600">*</span>
        </label>
        <input
          type="number"
          name="amount"
          placeholder="Enter Amount"
          value={values.amount}
          className={`
            border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 
            ${errors.amount && touched.amount ? "border-red-600" : ""}
          `}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.amount && errors.amount ? (
          <p className="text-red-500 pl-2 italic">{errors.amount}</p>
        ) : null}
      </div>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-5">
      <div className="w-full">
        <label>
          Description <span className="text-red-600">*</span>
        </label>
        <input
          type="text"
          name="description"
          placeholder="Enter description"
          value={values.description}
          className={`
            border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 
            ${errors.description && touched.description ? "border-red-600" : ""}
          `}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.description && errors.description ? (
          <p className="text-red-500 pl-2 italic">{errors.description}</p>
        ) : null}
      </div>
      <div className="w-full">
        <label>Category <span className="text-red-600">*</span></label>
        <select
          name="category"
          value={values.category}
          onChange={handleChange}
          onBlur={handleBlur}
          className={`
            border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 
            ${errors.category && touched.category ? "border-red-600" : ""}
          `}
        >
          <option value="">Select Category</option>
          <option value="Rent">Rent</option>
          <option value="New Equipment">New Equipment</option>
          <option value="Maintenance">Maintenance</option>
          <option value="SLA Gym Equipment">SLA Gym Equipment</option>
          <option value="SLA Surveillance">SLA Surveillance</option>
          <option value="Internet Connection">Internet Connection</option>
          <option value="Water Supply">Water Supply</option>
          <option value="House Keeping">House Keeping</option>
          <option value="Utility">Utility</option>
          <option value="Income to Owner">Income to Owner</option>
          <option value="Loan Return">Loan Return</option>
          <option value="Trainer Share">Trainer Share</option>
          <option value="Online Payments">Online Payments</option>
          <option value="Staff Accommodation">Staff Accommodation</option>
          <option value="Staff Food">Staff Food</option>
          <option value="Other">Other</option>
        </select>
        {touched.category && errors.category && (
          <p className="text-red-500 pl-2 italic">{errors.category}</p>
        )}
      </div>
    </div>

    {role !== 'ClubAdmin' && (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-5">
        <div className="w-full">
          <label>
            Location <span className="text-red-600">*</span>
          </label>
          <select
            name="location_id"
            value={values.location_id || ""}
            onChange={handleChange}
            onBlur={handleBlur}
            className={`border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ${
              errors.location_id && touched.location_id ? "border-red-600" : ""
            }`}
          >
            <option value="" disabled>
              Select Location
            </option>
            {locations?.map((location, index) => (
              <option key={index} value={location._id}>
                {location.name}
              </option>
            ))}
          </select>
          {touched.location_id && errors.location_id && (
            <p className="text-red-500 pl-2 italic">{errors.location_id}</p>
          )}
        </div>
        {/* Empty div to maintain grid balance */}
        <div className="w-full"></div>
      </div>
    )}

    <div className="flex justify-end items-center pt-3 mt-5 border-t">
      <button
        type="submit"
        className={`bg-blue-600 p-2 px-5 rounded-lg text-white font-medium hover:bg-blue-700 ${buttonLoading ? "cursor-not-allowed bg-gray-400" : ""}`}
        disabled={buttonLoading}
      >
        {buttonLoading ? "Submitting..." : "Submit"}
        {buttonLoading && (
          <CircularProgress
            size={20}
            className="ml-2 mt-1"
            sx={{ color: "white" }}
          />
        )}
      </button>
    </div>
  </form>
</CustomModal>



<CustomModal
  isModal={isViewModalOpen}
  handleModal={toggleViewModal}
  size="2xl"
>
  
    <div>
      <Tooltip title="" placement="bottom">
        <h1 className="font-bold text-3xl text-gx-ink-soft p-5 border-b mx-2">
          View Expense
        </h1>
        <div className="m-14">
          <Box>
            <div className="overflow-x-auto">
              <Table className="min-w-full">
                <TableBody>
                  <TableRow>
                    <TableCell>Title</TableCell>
                    <TableCell>{selectedExpense?.title}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Amount</TableCell>
                    <TableCell>{selectedExpense?.amount}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Description</TableCell>
                    <TableCell>{selectedExpense?.description}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Category</TableCell>
                    <TableCell>{selectedExpense?.category}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </div>
          </Box>
        </div>
      </Tooltip>
    </div>
  
</CustomModal>


      <CustomModal
        isModal={isDeleteModalOpen}
        handleModal={toggleDeleteModal}
        size="md"
      >
        <div className="m-5">
          <h2 className="text-xl font-medium">Delete Expense?</h2>
          <p className="text-gx-ink-soft mt-3">
            Are you sure you want to delete this expense?
          </p>
          <button
            className={`bg-red-600 p-2 px-5 rounded-lg text-white font-medium hover:bg-red-700 mt-5 float-right mb-5 ${buttonLoading ? "cursor-not-allowed bg-gray-400" : ""}`}
            // onClick={deleteExpense} // Temporarily disabled
            disabled={buttonLoading}
          >
            {buttonLoading ? "Deleting..." : "Delete"}
            {buttonLoading && (
              <CircularProgress
                size={20}
                className="ml-2 mt-1"
                sx={{ color: "white" }}
              />
            )}
          </button>
        </div>
      </CustomModal>
      {isPopupOpen && (
        <Popup
          onClose={() => setIsPopupOpen(false)}
          alertType={
            isSuccessAlert ? "success" : isFaliureAlert ? "failure" : ""
          }
          message={
            isSuccessAlert
              ? successMessage
              : isFaliureAlert
              ? failureMessage
              : ""
          }
        />
      )}
    </>
  );
}

export default Expense;
